// ── 심볼업 비용 데이터 ──────────────────────────────────
// 가격 변경 시 이 파일만 수정하세요.

export const ARCANE_AREAS   = ["소멸의여로","츄츄아일랜드","레헬른","아르카나","모라스","에스페라"];
export const AUTHENTIC_AREAS = ["세르니움","아르크스","오디움","도원경","아르테리아","카르시온"];

// [레벨, 조각수, 지역1, 지역2, 지역3, 지역4, 지역5, 지역6]
// ── 2026-09-16까지: 기존 비용 ──
const ARCANE_LEVEL_DATA_BEFORE = [
  [1,  12,   970000,  1210000,  1450000,  1690000,  1930000,  2170000],
  [2,  15,  1230000,  1530000,  1830000,  2130000,  2430000,  2730000],
  [3,  20,  1660000,  2060000,  2460000,  2860000,  3260000,  3660000],
  [4,  27,  2260000,  2800000,  3340000,  3880000,  4420000,  4960000],
  [5,  36,  3060000,  3780000,  4500000,  5220000,  5940000,  6660000],
  [6,  47,  4040000,  4980000,  5920000,  6860000,  7800000,  8740000],
  [7,  60,  5220000,  6420000,  7620000,  8820000, 10020000, 11220000],
  [8,  75,  6600000,  8100000,  9600000, 11100000, 12600000, 14100000],
  [9,  92,  8180000, 10020000, 11860000, 13700000, 15540000, 17380000],
  [10,111,  9990000, 12210000, 14430000, 16650000, 18870000, 21090000],
  [11,132, 12010000, 14650000, 17290000, 19930000, 22570000, 25210000],
  [12,155, 14260000, 17360000, 20460000, 23560000, 26660000, 29760000],
  [13,180, 16740000, 20340000, 23940000, 27540000, 31140000, 34740000],
  [14,207, 19450000, 23590000, 27730000, 31870000, 36010000, 40150000],
  [15,236, 22420000, 27140000, 31860000, 36580000, 41300000, 46020000],
  [16,267, 25630000, 30970000, 36310000, 41650000, 46990000, 52330000],
  [17,300, 29100000, 35100000, 41100000, 47100000, 53100000, 59100000],
  [18,335, 32830000, 39530000, 46230000, 52930000, 59630000, 66330000],
  [19,372, 36820000, 44260000, 51700000, 59140000, 66580000, 74020000],
];

// ── 2026-09-17부터: 아케인 심볼 강화 비용 30% 감소 반영 (실제 적용값 기준, 단순 ×0.7 아님) ──
const ARCANE_LEVEL_DATA_AFTER = [
  [1,  12,   670000,   840000,  1010000,  1180000,  1350000,  1510000],
  [2,  15,   860000,  1070000,  1280000,  1490000,  1700000,  1910000],
  [3,  20,  1160000,  1440000,  1720000,  2000000,  2280000,  2560000],
  [4,  27,  1580000,  1960000,  2340000,  2720000,  3090000,  3470000],
  [5,  36,  2140000,  2640000,  3150000,  3650000,  4150000,  4660000],
  [6,  47,  2820000,  3480000,  4140000,  4800000,  5460000,  6110000],
  [7,  60,  3650000,  4490000,  5330000,  6170000,  7010000,  7850000],
  [8,  75,  4620000,  5670000,  6720000,  7770000,  8820000,  9870000],
  [9,  92,  5720000,  7010000,  8300000,  9590000, 10870000, 12160000],
  [10,111,  6990000,  8540000, 10100000, 11650000, 13200000, 14760000],
  [11,132,  8400000, 10250000, 12100000, 13950000, 15790000, 17640000],
  [12,155,  9980000, 12150000, 14320000, 16490000, 18660000, 20830000],
  [13,180, 11710000, 14230000, 16750000, 19270000, 21790000, 24310000],
  [14,207, 13610000, 16510000, 19410000, 22300000, 25200000, 28100000],
  [15,236, 15690000, 18990000, 22300000, 25600000, 28910000, 32210000],
  [16,267, 17940000, 21670000, 25410000, 29150000, 32890000, 36630000],
  [17,300, 20370000, 24570000, 28770000, 32970000, 37170000, 41370000],
  [18,335, 22980000, 27670000, 32360000, 37050000, 41740000, 46430000],
  [19,372, 25770000, 30980000, 36190000, 41390000, 46600000, 51810000],
];

// 아케인 심볼 비용 이력 — bossData.js의 BOSS_PRICE_HISTORY와 동일한 패턴.
// 다음에 또 아케인(또는 어센틱/그랜드 어센틱) 비용이 바뀌면 이 배열에 기간 블록만 추가하면 됨.
const ARCANE_LEVEL_DATA_HISTORY = [
  { from: "2000-01-01", to: "2026-09-16", data: ARCANE_LEVEL_DATA_BEFORE },
  { from: "2026-09-17", to: "9999-12-31", data: ARCANE_LEVEL_DATA_AFTER },
];

export function getArcaneLevelData(date) {
  const d = date || ARCANE_LEVEL_DATA_HISTORY[ARCANE_LEVEL_DATA_HISTORY.length - 1].from;
  const found = ARCANE_LEVEL_DATA_HISTORY.find(h => d >= h.from && d <= h.to);
  return found ? found.data : ARCANE_LEVEL_DATA_HISTORY[ARCANE_LEVEL_DATA_HISTORY.length - 1].data;
}

// 하위 호환용 — 직접 이 배열을 참조하는 곳이 있다면 항상 "현재(가장 최신)" 비용을 가리킴.
// 날짜별 계산이 필요한 곳은 반드시 getArcaneLevelData(date) 또는 calcSymbolCost(..., date)를 사용할 것.
export const ARCANE_LEVEL_DATA = ARCANE_LEVEL_DATA_AFTER;

export const AUTHENTIC_LEVEL_DATA = [
  [1,  2,  36500000,  41700000,  46900000,  52200000,  57400000,  62600000],
  [2,  3,  91200000, 104800000, 118500000, 132200000, 145900000, 159600000],
  [3,  4, 160700000, 186100000, 211500000, 236800000, 262200000, 287600000],
  [4,  7, 241900000, 282200000, 322500000, 362800000, 403200000, 443500000],
  [5, 10, 331500000, 390000000, 448500000, 507000000, 565500000, 624000000],
  [6, 15, 426200000, 506100000, 586000000, 666000000, 745900000, 825800000],
  [7, 21, 522900000, 627400000, 732000000, 836600000, 941200000,1045800000],
  [8, 28, 618200000, 750700000, 883200000,1015600000,1148100000,1280600000],
  [9, 36, 709000000, 872600000,1036200000,1199800000,1363500000,1527100000],
  [10,45, 792000000, 990000000,1188000000,1386000000,1584000000,1782000000],
];

// 그랜드 어센틱 심볼 (주스탯 증가 없음, 지역 2개)
export const GRAND_AUTHENTIC_AREAS = ["탈라하트", "기어드락"];

// [레벨, 조각수, 탈라하트, 기어드락]
export const GRAND_AUTHENTIC_LEVEL_DATA = [
  [1,  2,   113600000,   139700000],
  [2,  3,   293300000,   361700000],
  [3,  4,   535800000,   662700000],
  [4,  7,   837700000,  1039300000],
  [5, 10,  1196000000,  1488500000],
  [6, 15,  1607200000,  2006800000],
  [7, 21,  2068300000,  2591200000],
  [8, 28,  2576000000,  3238400000],
  [9, 36,  3126900000,  3945000000],
  [10,45,  3718000000,  4708000000],
];

// 로컬 날짜 기준 YYYY-MM-DD (UTC 변환 X — 반드시 로컬 기준으로. 이유는 인수인계 문서의
// "⏰ 타임존/날짜 처리 원칙" 참고. toISOString() 절대 쓰지 말 것.)
function localToday() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

export function calcSymbolCost(type, currentLv, targetLv, area, date) {
  const isGrand = type === "grand";
  const usedDate = date || localToday();
  const data  = isGrand ? GRAND_AUTHENTIC_LEVEL_DATA
              : type === "arcane" ? getArcaneLevelData(usedDate) : AUTHENTIC_LEVEL_DATA;
  const areas = isGrand ? GRAND_AUTHENTIC_AREAS
              : type === "arcane" ? ARCANE_AREAS : AUTHENTIC_AREAS;
  const maxLv = isGrand ? 11 : type === "arcane" ? 20 : 11;
  if (!currentLv || !targetLv || currentLv < 1 || targetLv > maxLv || currentLv >= targetLv)
    return { meso: 0, pieces: 0 };
  const col = 2 + Math.max(0, areas.indexOf(area));
  let meso = 0, pieces = 0;
  for (let lv = currentLv; lv < targetLv; lv++) {
    const row = data[lv - 1];
    if (!row) break;
    pieces += row[1];
    meso   += row[col] || 0;
  }
  return { meso, pieces };
}
